import config from '../../../config/config';
import DefaultApiLimit from '../../../config/defaultLimit';
import getRequest from '../base/get';
import patchRequest from '../base/patch';
import postRequest from '../base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Add maintenance schedule API
   * @param {any} data - The schedule data
   * @returns {any} A promise that resolves with the response
   */
  addMaintenanceSchedule: (data: any): Promise<any> => {
    return postRequest(`${config.cpo.commonApiUrl}api/common/v1/maintenance-schedule`, data, false);
  },
  /**
   * Can existing schedules and add maintenance schedule API
   * @param {any} data - The schedule data
   * @returns {any} A promise that resolves with the response
   */
  cancelScheduleAndAddMaintenanceSchedule: (data: any): Promise<any> => {
    return postRequest(
      `${config.commonApiUrl}api/common/v1/maintenance-schedule/cancel-and-create`,
      data,
      false,
    );
  },
  /**
   * Fetch maintenance schedule API
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the maintenance schedules
   */
  fetchMaintenanceSchedule: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/common/v1/maintenance-schedule`, {
      ...parameters,
    });
  },
  /**
   * Fetch maintenance schedule API for export
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the exported data
   */
  fetchMaintenanceScheduleExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/common/v1/maintenance-schedule/export-data`, {
      ...parameters,
    });
  },
  /**
   * Edit maintenance schedule API
   * @param {any} id - The schedule ID
   * @param {any} data - The schedule data
   * @returns {any} A promise that resolves with the response
   */
  editMaintenanceSchedule: (id: number | string | null, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/common/v1/maintenance-schedule/${id}`,
      data,
      false,
    );
  },

  /**
   * Fetch report API
   * @returns {any} A promise that resolves with the list filters
   */
  fetchListFilters: () => {
    return getRequest(`${config.commonApiUrl}api/common/v1/maintenance-schedule/list-filters`);
  },
};
